<template>
  <div class="contact-us">
    <div class="contact-container">
      <!-- 联系信息部分 -->
      <section class="contact-info">
        <h2>{{ t('contact.info_title') }}</h2>
        <div class="info-items">
          <div class="info-item">
            <i class="fas fa-map-marker-alt"></i>
            <div class="info-content">
              <h3>{{ t('contact.address_title') }}</h3>
              <p>{{ t('contact.address_value') }}</p>
            </div>
          </div>
          <div class="info-item">
            <i class="fas fa-phone"></i>
            <div class="info-content">
              <h3>{{ t('contact.phone_title') }}</h3>
              <p>{{ t('contact.phone_value') }}</p>
            </div>
          </div>
          <div class="info-item">
            <i class="fas fa-envelope"></i>
            <div class="info-content">
            <h3>{{ t('contact.email_title') }}</h3>
            <p><a href="mailto:service@765.info">service@765.info</a></p>
            </div>
          </div>
          <div class="info-item">
            <i class="fas fa-clock"></i>
            <div class="info-content">
              <h3>{{ t('contact.hours_title') }}</h3>
              <p>{{ t('contact.hours_value') }}</p>
            </div>
          </div>
        </div>
      </section>

      <!-- 联系表单部分 -->
      <section class="contact-form">
        <h2>{{ t('contact.form_title') }}</h2>
        <form @submit.prevent="handleSubmit">
          <div class="form-group">
            <label for="name">{{ t('contact.name') }}</label>
            <input
              type="text"
              id="name"
              v-model="formData.name"
              :placeholder="t('contact.name_placeholder')"
              required
              :disabled="isSubmitting"
            />
          </div>
          <div class="form-group">
            <label for="email">{{ t('contact.email') }}</label>
            <input
              type="email"
              id="email"
              v-model="formData.email"
              :placeholder="t('contact.email_placeholder')"
              required
              :disabled="isSubmitting"
            />
          </div>
          <div class="form-group">
            <label for="subject">{{ t('contact.subject') }}</label>
            <input
              type="text"
              id="subject"
              v-model="formData.subject"
              :placeholder="t('contact.subject_placeholder')"
              required
              :disabled="isSubmitting"
            />
          </div>
          <div class="form-group">
            <label for="message">{{ t('contact.message') }}</label>
            <textarea
              id="message"
              v-model="formData.message"
              :placeholder="t('contact.message_placeholder')"
              rows="5"
              required
              :disabled="isSubmitting"
            ></textarea>
          </div>
          <p class="email-note">
            {{ t('contact.email_note') }}
          </p>
          <button type="submit" class="submit-button" :disabled="isSubmitting">
            {{ isSubmitting ? '发送中...' : t('contact.submit') }}
          </button>
        </form>
        <div v-if="submitSuccess" class="success-message">
          {{ t('contact.form_success') }}
        </div>
        <div v-if="submitError" class="error-message">
          {{ errorMessage }}
        </div>
      </section>
    </div>

    <!-- 地图部分 -->
    <!-- <section class="map-section">
      <h2>{{ t('contact.location') }}</h2>
      <div class="map-container">

        <div class="map-placeholder">
          {{ t('contact.map_placeholder') }}
        </div>
      </div>
    </section> -->
  </div>
</template>

<script>
import { useI18n } from 'vue-i18n'
import { ref, reactive } from 'vue'
import api from '../api'

export default {
  name: 'ContactUs',
  setup() {
    const { t } = useI18n()
    const submitSuccess = ref(false)
    const submitError = ref(false)
    const errorMessage = ref('')
    const isSubmitting = ref(false)
    const formData = reactive({
      name: '',
      email: '',
      subject: '',
      message: ''
    })

    const handleSubmit = async () => {
      isSubmitting.value = true
      submitSuccess.value = false
      submitError.value = false
      
      try {
        // 使用后端API发送邮件
        const response = await api.post(`/api/contact-us`, {
          name: formData.name,
          email: formData.email,
          subject: formData.subject,
          message: formData.message
        })
        
        // 处理成功响应
        if (response.data.success) {
          console.log('邮件发送成功:', response.data)
          submitSuccess.value = true
          
          // 重置表单
          formData.name = ''
          formData.email = ''
          formData.subject = ''
          formData.message = ''
        } else {
          submitError.value = true
          errorMessage.value = response.data.message || t('contact.errorMessage') || '邮件发送失败，请稍后再试。'
        }
        
        // 3秒后隐藏成功/错误消息
        setTimeout(() => {
          submitSuccess.value = false
          submitError.value = false
        }, 3000)
      } catch (error) {
        console.error('邮件发送失败:', error)
        submitError.value = true
        errorMessage.value = error.response?.data?.message || '邮件发送失败，请稍后再试。'
        
        // 3秒后隐藏错误消息
        setTimeout(() => {
          submitError.value = false
        }, 3000)
      } finally {
        isSubmitting.value = false
      }
    }

    return {
      t,
      formData,
      submitSuccess,
      submitError,
      errorMessage,
      isSubmitting,
      handleSubmit
    }
  }
}
</script>

<style scoped>
.contact-us {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
}

.contact-container {
  display: flex;
  gap: 40px;
  margin-bottom: 40px;
}

section {
  flex: 1;
}

h2 {
  color: #2c3e50;
  margin-bottom: 30px;
  position: relative;
  padding-bottom: 10px;
}

h2::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 60px;
  height: 3px;
  background-color: #42b983;
}

.info-items {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.info-item {
  display: flex;
  align-items: flex-start;
  gap: 15px;
  padding: 15px;
  background-color: #f9f9f9;
  border-radius: 5px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

.info-item i {
  font-size: 24px;
  color: #42b983;
  width: 24px;
}

.info-content h3 {
  margin: 0 0 5px 0;
  font-size: 1.1em;
  color: #2c3e50;
}

.info-content p {
  margin: 0;
  color: #666;
}

.form-group {
  margin-bottom: 20px;
}

label {
  display: block;
  margin-bottom: 5px;
  color: #2c3e50;
}

input,
textarea {
  width: 100%;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 1em;
}

textarea {
  resize: vertical;
}

.submit-button {
  background-color: #42b983;
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 1em;
  transition: background-color 0.3s;
}

.submit-button:hover {
  background-color: #3aa876;
}

.success-message {
  margin-top: 20px;
  padding: 15px;
  background-color: #d4edda;
  color: #155724;
  border-radius: 4px;
  text-align: center;
}

.error-message {
  margin-top: 20px;
  padding: 15px;
  background-color: #f8d7da;
  color: #721c24;
  border-radius: 4px;
  text-align: center;
}

.email-note {
  margin-bottom: 15px;
  font-size: 0.9em;
  color: #666;
  font-style: italic;
}

.submit-button:disabled {
  background-color: #95d5b7;
  cursor: not-allowed;
}

.map-section {
  margin-top: 40px;
}

.map-container {
  height: 400px;
  background-color: #f9f9f9;
  border-radius: 5px;
  overflow: hidden;
}

.map-placeholder {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #666;
  font-style: italic;
}

@media (max-width: 768px) {
  .contact-container {
    flex-direction: column;
  }

  .contact-info,
  .contact-form {
    width: 100%;
  }

  .map-container {
    height: 300px;
  }
}
</style>